// extracted by mini-css-extract-plugin
export default {"sortableHeader":"TableLight__sortableHeader___D9Had"};